import {Alert, AlertColor, AlertTitle, Box, Collapse, InputLabel} from "@mui/material"
import React, {useState} from "react"

import {ClearCache} from "../../../core/widgets/browser/ClearCache"
import {SxPropsMap} from "../../helper/HelperType"
import {OpenIcon} from "../icon/OpenIcon"

const SX: SxPropsMap = {
    collapse: {display: "flex", flexDirection: "column", gap: 2, marginTop: "20px"},
    label: {fontWeight: "bold"},
    message: {display: "flex", gap: 2, justifyContent: "space-between", alignItems: "center", whiteSpace: "pre-line"},
    alert: {"& .MuiAlert-message": {flexGrow: 1}, width: "inherit", maxWidth: "inherit", minWidth: "inherit"},
    input: {whiteSpace: "pre-wrap", wordWrap: "break-word"},
}

type Props = {
    message: string,
    type: AlertColor,
    title?: string,
    stacktrace?: string,
    params?: string,
    data?: string,
    url?: string,
    clear?: boolean,
}

export function Error(props: Props) {
    const {message, type, stacktrace, title, params, data, url, clear} = props
    const [isOpen, setIsOpen] = useState(false)
    const isStacktrace = !!stacktrace

    return (
        <Alert sx={SX.alert} severity={type} onClick={() => setIsOpen(!isOpen)} action={<OpenIcon show={isStacktrace} open={isOpen}/>}>
            <AlertTitle>{title ?? type.toString().toUpperCase()}</AlertTitle>
            <Box sx={SX.message}>
                <Box>
                    <Box>{message}</Box>
                    {clear && (
                        <Box>
                            It can be caused because of local cache corruption.
                            You can try to clean it, sometimes it can fix the problem.
                        </Box>
                    )}
                </Box>
                {clear && <ClearCache/>}
            </Box>
            <Collapse in={isStacktrace && isOpen}>
                <Box sx={SX.collapse} onClick={handleDisable}>
                    {renderInfoBox("URL", url)}
                    {renderInfoBox("Request Params", params, true)}
                    {renderInfoBox("Request Body", data, true)}
                    {renderInfoBox("Stacktrace", stacktrace)}
                </Box>
            </Collapse>
        </Alert>
    )

    function renderInfoBox(name: string, value?: string, json: boolean = false) {
        const label = json ? JSON.stringify(value, null, 4) : value
        const labelNotEmpty = label == "{}" || label == "[]" ? undefined : label
        return (
            <Box>
                <Box sx={SX.label}>{name}</Box>
                <InputLabel sx={SX.input}>{labelNotEmpty ?? "-"}</InputLabel>
            </Box>
        )
    }

    function handleDisable(e: React.MouseEvent) {
        e.preventDefault()
        e.stopPropagation()
    }
}
